// extracted by mini-css-extract-plugin
module.exports = {"stopUserEvents":"BB_JobAds_stopUserEvents_2L5zO","stopUserEventsMobile":"BB_JobAds_stopUserEventsMobile_3C7e7","buttonDisabled":"BB_JobAds_buttonDisabled_1HwKZ"};